import React, { Component } from 'react';
import axios from 'axios';
import Header from '../Header';
import { Accordion, Card } from "react-bootstrap";
import parse from 'html-react-parser';
import LoadingScreen from '../common/loading-screen';
import loader from '../../images/site-loader.gif'
import partners from '../../images/STBAPLockup_V3.jpg';
import cardFace from '../../images/card-face.png';
import TableHeaderBenefits from '../common/table-header';

import { BIN_CHECK, NEW_SCB_BENEFITS, SCB_BENEFITS, SCB_LEAD_EMAIL_CHECK } from '../../constants/index';
import { validFromOctober2025, validUntilSeptember2025, getUrl, validCode, validBIN } from '../helper';

import '../../css/style.css';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            code: '',
            codeValid: true,
            bin: '',
            errorMessage: '',
            successMessage: '',
            loading: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handelClick = this.handelClick.bind(this);
    }

    handleChange = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value,
            errorMessage: '',
        })
    };

    handelClick = () => {
        this.setState({ loading: true });

        if (!this.state.code) {
            this.setState({
                loading: false,
                code: '',
                errorMessage: 'Redemption Code is required.'
            });
            return;
        }
        if (!this.state.bin) {
            this.setState({
                loading: false,
                bin: '',
                errorMessage: 'BIN is required.'
            })
            return;
        }
        if (!validCode(this.state.code)) {
            console.log("this.state", this.state);
            this.setState({
                loading: false,
                errorMessage: "ErrorCode (1032): The unique redemption code is not valid. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance."
            })
            return;
        }
        if (validBIN(this.state.bin)) {
            this.setState({
                loading: false,
                errorMessage: "ErrorCode (1033) : The first 6 digits of your credit card is not valid. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance."
            })
            return;
        }
        // if(!validEmail(this.state.code)){
        //     this.setState({ 
        //         loading      : false,
        //         codeValid   : false,
        //         errorMessage : 'Redemption Code not valid.'});
        //     return;
        // }
        axios.post(`${BIN_CHECK}`, {
            partnerName: "SCB",
            bin: this.state.bin
        })
            .then(response => {
                console.log('response', response.data);
                if (response.data.statusCode === 200) {
                    axios.post(SCB_LEAD_EMAIL_CHECK, {
                        code: this.state.code
                    }).then(response => {
                        console.log("Code check", response)
                        if (response.data.coupon_code) {
                            const { member_id } = response.data.member_data
                            const urlRoot = getUrl().urlRoot;
                            const bc = getUrl().scb_bc;
                            //const url = urlRoot + "sg/registration?redirect=F&bc=" + bc + "&coupon=" + response.data.coupon_code + "&leadid=" + member_id;
                            const url = urlRoot + `partner/standard-chartered-bank/?couponCode=${response.data.coupon_code}`;
                            console.log("URL", url);
                            window.location.href = url;
                        } else {
                            console.log('Error fetching code', response)
                            
                            this.setState({
                                errorMessage: "ErrorCode (1048): This coupon code has been used. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance."
                            })
                        }
                    }).catch(err => {
                        console.log('Error fetching code', err.response)
                        // this.setState({
                        //     errorMessage: "Unable to Verify Redemption Code"
                        // })
                        this.setState({
                            errorMessage: "ErrorCode (1032): The unique redemption code is not valid. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance."
                        })
                    })
                    // if(response.data.coupon_code){
                    //     const urlRoot = getUrl().urlRoot;
                    //     const bc = getUrl().subaru_bc;
                    //     const url =  urlRoot + "au/registration?redirect=F&bc="+bc+"&email="+this.state.email+"&coupon="+response.data.coupon_code;
                    //     console.log("URL", url);
                    //     window.location.href = url;
                    // }

                    this.setState({ loading: false });
                } else {
                    switch (response.data.statusCode) {
                        case 400:
                            this.setState({ errorMessage: `ErrorCode (1027): We can't seem to proceed... Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team for further assistance` })
                            break;
                        case 401:
                            console.log("response from status", response);
                            this.setState({ errorMessage: `ErrorCode (1032): The unique redemption code is not valid. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance.` })
                            break;
                        case 404:
                            this.setState({ errorMessage: `ErrorCode (1028): We can't seem to proceed... Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team for further assistance` })
                            break;
                        case 500:
                            this.setState({ errorMessage: `ErrorCode (1029): We can't seem to proceed... Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team for further assistance` })
                            break;
                        default:
                            this.setState({ errorMessage: "Oops! Something went wrong, Please try again" })
                    }
                    this.setState({ loading: false })
                }
            }).catch(err => {
                if (err.response.status === 403) {
                    this.setState({ errorMessage: "It appears that you are logged in as a member. Please contact Member Services for assistance --> we need to hyperlink 'Member Services' so that help is intuitive" })
                }
            })
    };

    render() {
        const { errorMessage, loading, successMessage } = this.state;
        let new_benefits;
        if (NEW_SCB_BENEFITS) {
            new_benefits = NEW_SCB_BENEFITS.map((item, index) =>
                <Card key={index} className="benefits">
                    <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                        <div className="row d-flex ">
                            <div className="mb-0 col-10 col-md-11 accordion-title-text">
                                {item.title}
                            </div>
                            <div className="mb-0 col-2 col-md-1">
                                <img alt="plus-symbol" src="/images/plus-symbol.png" width="22" />
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    {parse(item.description)}
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            );
        }
        var errrorClass = "";
        if (!this.state.codeValid) {
            errrorClass = "validation-error"
        }
        return (
            <div class="hotelSales-wrapper">
                <Header
                    handleLeaderBoard={this.handleLeaderBoard}
                    bannerClass="banner-scb" />
                <div className="container">
                    <div className="d-flex justify-between mx-auto row">
                        <div class="mt-5 container col-8 px-0 mx-0">
                            <h2>Redeem your complimentary ALL Accor+ Explorer membership, Courtesy of
                                Standard Chartered Beyond Credit Card</h2>
                            <p>As a Standard Chartered Beyond Credit Card member with a SC Priority Private or Private Banking relationship, you are
                                entitled to a 12-month ALL Accor+ Explorer membership.</p>
                            <p>ALL Accor+ Explorer, Asia Pacific&#39;s most expansive travel, dining and lifestyle programme enables you to do
                                more, in Singapore and across Asia Pacific. Enjoy exclusive member benefits at over 1,000
                                participating Accor hotels and resorts including international hotel brands such as Fairmont, Sofitel,
                                Swissôtel, and more.</p>
                        </div>
                        <div class="mt-5 brand-container col-4">
                            {/* SCB | Accorplus Logo */}
                            <div className="partners-card d-flex flex-column justify-content-center">
                                <div className="card-face">
                                    <img src={cardFace} width="420px" />
                                </div>
                                <img src={partners} width="100%" />
                            </div>
                        </div>
                    </div>

                    <TableHeaderBenefits tableTitle={validFromOctober2025("ALL ACCOR+ EXPLORER BENEFITS")} />
                    <div className="container accordion-container mt-3 benefits-container mb-5">
                        <Accordion defaultActiveKey="0">
                            {new_benefits}
                        </Accordion>
                    </div>

                    <div className="container">
                        <h5 class="px-0 py-3 text-center text-bold">Enter the first 6 digits of your Standard Chartered Beyond Credit Card and <br></br>
                            your unique redemption code to start experiencing more:</h5>
                        <div class="py-3">
                            <input type="text" name="bin" class={`email-check-input ${errrorClass}`} placeholder="First 6 digits of your credit card" onChange={this.handleChange}></input>
                            <input type="text" name="code" class={`email-check-input mt-2 ${errrorClass}`} placeholder="Enter code" onChange={this.handleChange}></input>
                            {successMessage ? (
                                <div className="my-2 text-bold text-center">
                                    {successMessage}
                                </div>
                            ) : errorMessage ? (
                                <div className="my-2 text-bold text-center text-danger" dangerouslySetInnerHTML={{ __html: this.state.errorMessage }}>
                                </div>
                            ) : null}
                            {loading ? (
                                // <LoadingScreen/>
                                <img src={loader} alt="loading" className="d-flex justify-center text-center mx-auto" />
                            ) : (
                                <button class="email-check-input-submit btn btn-primary mt-2 button theme-primary" onClick={this.handelClick}>Submit <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M17.42 10l-6.951-6.95-1.326 1.325 4.687 4.688H2.97v1.874H13.83l-4.687 4.688 1.326 1.326L17.419 10z"></path></svg></button>
                            )}
                        </div>
                    </div>

                    <div class="container terms_conditions mt-4">
                        <p class="title"><strong>Terms and conditions:</strong></p>
                        <p>- This offer is open to eligible Standard Chartered Beyond Principal cardholders with a SC Priority Private or Private Banking relationship.</p>

                        <p>- Eligible Cardholders are entitled to a 12-month ALL Accor+ Explorer membership from the day of membership enrolment.</p>
                        
                        <p>- Upon successful registration via the dedicated  ALL Accor+ Explorer landing page, your membership will be processed within 2 business days. Be sure to follow the steps in the Welcome E-mail to activate your membership.</p>

                        <p>- After activating your membership, download the Accor ALL app to access your digital ALL Accor+  Explorer card to enjoy your member benefits straight away.</p>

                        <p>- Once a redemption has been made, it cannot be cancelled or exchanged for cash, rewards points, or any other item.</p>

                        <p>- *Standard terms and conditions governing the use of an ALL Accor+ Explorer membership apply, and are subject to changes without prior notice. Please view the <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">ALL Accor+ Explorer membership terms and conditions</a> for more details. T&Cs apply and are subject to changes without prior notice.</p>
                        <p>- If you have a current ALL Accor+ Explorer membership, you may wish to register for your ALL Accor+ Explorer
                            Plus membership courtesy of Standard Chartered Beyond Credit Card using an unused email
                            address.</p>
                        <p>- Member benefits across multiple ALL Accor+ Explorer memberships cannot be merged or stacked.</p>
                        <p>- Stay or dining exceptions may apply to the standard ALL Accor+ Explorer member benefits. Please refer to the <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">member benefits exception list</a> for more details.</p>
                        <p>- For inquiries on your ALL Accor+ Explorer membership, please contact the ALL Accor+ Explorer Member Services team via the <a href="https://accorplushelp.zendesk.com/hc/en-au" target="_blank" rel="noreferrer">Member Help Centre</a>.</p>
                        <p class='hidden'>
                            10-1-2025
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default (Home);
